"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconStarSolid = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M49.53 64.29a7.09 7.09 0 0 1-3.24-.8l-9.46-5a4 4 0 0 0-3.66 0l-9.46 5a6.94 6.94 0 0 1-10.07-7.32l1.81-10.54a4 4 0 0 0-1.13-3.48l-7.66-7.46a6.93 6.93 0 0 1 3.84-11.83l10.58-1.54a3.92 3.92 0 0 0 3-2.16l4.73-9.58a6.93 6.93 0 0 1 12.44 0L46 19.16a3.94 3.94 0 0 0 3 2.16l10.5 1.54a6.93 6.93 0 0 1 3.84 11.83l-7.66 7.46a4 4 0 0 0-1.13 3.49l1.81 10.53a6.95 6.95 0 0 1-6.83 8.12z"
  })),
  height: undefined,
  width: undefined
});
IconStarSolid.displayName = 'IconStarSolid';
var _default = IconStarSolid;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/star-solid.js
// module id = 591
// module chunks = 0